module.exports = __webpack_public_path__ + "img/thumbnail_PrzewalskisHorse_m_normal.e6a204f8.png";